import type { Device, WsEvent } from '@findmy/shared';

/** Applies one live-feed event to the cached device list. */
export function applyEvent(devices: Device[] | undefined, event: WsEvent): Device[] | undefined {
  if (!devices) return devices;
  switch (event.type) {
    case 'device.updated': {
      const index = devices.findIndex((d) => d.id === event.device.id);
      if (index === -1) return [...devices, event.device];
      const next = devices.slice();
      next[index] = event.device;
      return next;
    }
    case 'device.removed':
      return devices.filter((d) => d.id !== event.deviceId);
    case 'command.updated':
      return devices;
  }
}
